import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import IconBack from './svg/IconBack';

function BackButton({ onClick }) {
  return (
    <div className={`align`} onClick={onClick} >
      <IconBack size={24} color={Config.TYPE_SECONDARY} className={`cf-icon-fill-v2`} />
    </div>
  )
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default BackButton;
